import { render, staticRenderFns } from "./DoorMagnetic.vue?vue&type=template&id=6a43f9df&scoped=true&"
import script from "./DoorMagnetic.vue?vue&type=script&lang=js&"
export * from "./DoorMagnetic.vue?vue&type=script&lang=js&"
import style0 from "./DoorMagnetic.vue?vue&type=style&index=0&id=6a43f9df&lang=scss&scoped=true&"
import style1 from "./DoorMagnetic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43f9df",
  null
  
)

export default component.exports